import Typed from 'typed.js';
import React, { Component } from 'react';

class TypedReact extends Component {
  componentDidMount() {
  	// If you want to pass more options as props, simply add
    // your desired props to this destructuring assignment.
    const { strings } = this.props;
    // You can pass other options here, such as typing speed, back speed, etc.
    const options = {
    	strings: strings,
      loop: true,
      typeSpeed: 100,
      backSpeed: 50,
      backDelay: 2000
    };
    // this.el refers to the <span> in the render() method
    this.typed = new Typed(this.el, options);
  }

  componentWillUnmount() {
  	// Make sure to destroy Typed instance on unmounting
    // to prevent memory leaks
    this.typed.destroy();
  }

  render() {
    return (
      <div className="wrap">
        <h2>I'm a <span style={{ whiteSpace: 'pre', color: '#0563bb'} } ref={(el) => { this.el = el; }} />.</h2>
      </div>
    );
  }
}


export default TypedReact;


// WEBPACK FOOTER //
// ./src/components/TypedReact.js